export default function ExtraTables({
  values,
  handleChange,
  labelStyle,
  inputStyle,
  errors,
}) {
  const hasLanguageSkills =
    values.englishSkills && values.chineseSkills && values.vietnamSkills;
  const SKILL_LEVELS = ["VERY_GOOD", "GOOD", "MODERATE", "SOFT"];
  const EDUCATION_LEVELS = [
    "HIGHT_SCHOOL",
    "DIPLOMA",
    "BACHELOR_DEGREE",
    "MASTER_DEGREE",
    "DOCTORATE",
    "OTHER",
  ];
  const EDU_INDEX = {
    educationLevel: 0,
    educationalInstitution: 1,
    subject: 2,
    academicYear: 3,
    grade: 4,
  };
  const WORK_INDEX = {
    previousPlaceOfWork: 0,
    oldPosition: 1,
    responsibilities: 2,
    reasonForResignation: 3,
    workExperience: 4,
  };
  return (
    <>
      {/* ປະຫວັດການສຶກສາ */}
      <div style={{ marginTop: "1.5rem" }}>
        <label
          style={{ ...labelStyle, fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}
        >
          ປະຫວັດການສຶກສາ
        </label>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div
            style={{
              minWidth: "720px",
              display: "grid",
              gridTemplateColumns: "1.1fr 1.4fr 1.1fr 1fr 0.8fr",
              border: "1.5px solid #1f2937",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            {[
              "ລະດັບການສຶກສາ",
              "ສະຖາບັນການສຶກສາ",
              "ສາຂາວິຊາ",
              "ສົກປີ ສຶກສາ",
              "ຄະແນນສະເລ່ຍ",
            ].map((h, i) => (
              <div
                key={`edu-h-${i}`}
                style={{
                  padding: 10,
                  fontWeight: 700,
                  fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  textAlign: "center",
                  background: "#dc2626",
                  borderRight: i < 4 ? "1px solid #1f2937" : "none",
                  borderBottom: "1px solid #1f2937",
                  color: "white",
                  whiteSpace: "nowrap",
                }}
              >
                {h}
              </div>
            ))}

            {[0, 1, 2].map((rowIdx) => (
              <>
                {[
                  { key: "educationLevel", ph: "HIGHT_SCHOOL/DIPLOMA/..." },
                  {
                    key: "educationalInstitution",
                    ph: "ຊື່ໂຮງຮຽນ/ມະຫາວິທະຍາໄລ",
                  },
                  { key: "subject", ph: "ສາຂາວິຊາ" },
                  { key: "academicYear", ph: "ສົກປີ ສຶກສາ" },
                  { key: "grade", ph: "GPA/ເກຣດ" },
                ].map((c, i) => (
                  <div
                    key={`edu-${rowIdx}-${i}`}
                    style={{
                      borderRight: i < 4 ? "1px solid #1f2937" : "none",
                      borderBottom: rowIdx < 2 ? "1px solid #1f2937" : "none",
                    }}
                  >
                    {c.key === "educationLevel" ? (
                      <select
                        name={`educationLevel[${rowIdx}][${EDU_INDEX[c.key]}]`}
                        value={
                          values.educationLevel?.[rowIdx]?.[EDU_INDEX[c.key]] ||
                          ""
                        }
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: 10,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          fontSize: "clamp(0.9rem, 0.1vw, 1rem)",
                        }}
                      >
                        <option value="">ເລືອກ</option>
                        {EDUCATION_LEVELS.map((level) => {
                          const CLASS_LABELS = {
                            HIGHT_SCHOOL: "ມັດທະຍົມ",
                            DIPLOMA: "ຊັ້ນສູງ",
                            BACHELOR_DEGREE: "ປະລິນຍາຕີ",
                            MASTER_DEGREE: "ປະລິນຍາໂທ",
                            DOCTORATE: "ປະລິນຍາເອກ",
                            OTHER: "ອື່ນໆ",
                          };
                          return (
                            <option key={level} value={level}>
                              {CLASS_LABELS[level]}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <input
                        type="text"
                        name={`educationLevel[${rowIdx}][${EDU_INDEX[c.key]}]`}
                        value={
                          values.educationLevel?.[rowIdx]?.[EDU_INDEX[c.key]] ||
                          ""
                        }
                        onChange={handleChange}
                        placeholder={c.ph}
                        style={{
                          width: "100%",
                          padding: 10,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          fontSize: "clamp(0.65rem, 1vw, 0.85rem)",
                        }}
                      />
                    )}
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
        {errors.educationLevel && (
          <p className="error-text">{errors.educationLevel}</p>
        )}
      </div>

      {/* ປະຫວັດການເຮັດວຽກ */}
      <div style={{ marginTop: "1.5rem" }}>
        <label
          style={{ ...labelStyle, fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}
        >
          ປະຫວັດການເຮັດວຽກ
        </label>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div
            style={{
              minWidth: "720px",
              display: "grid",
              gridTemplateColumns: "1.4fr 1fr 1.4fr 1.2fr 0.8fr",
              border: "1.5px solid #1f2937",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            {[
              "ບ່ອນເຮັດວຽກທີ່ຜ່ານມາ",
              "ຕຳແໜ່ງເກົ່າ",
              "ຫນ້າທີ່ຮັບຜິດຊອບ",
              "ເຫດຜົນທີ່ລາອອກ",
              "ປະສົບການ (ປີ)",
            ].map((h, i) => (
              <div
                key={`work-h-${i}`}
                style={{
                  padding: 10,
                  fontWeight: 700,
                  fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  textAlign: "center",
                  background: "#dc2626",
                  borderRight: i < 4 ? "1px solid #1f2937" : "none",
                  borderBottom: "1px solid #1f2937",
                  color: "white",
                  whiteSpace: "nowrap",
                }}
              >
                {h}
              </div>
            ))}

            {[0, 1, 2].map((rowIdx) => (
              <>
                {[
                  { key: "previousPlaceOfWork", ph: "ຊື່ບໍລິສັດ/ອົງກອນ" },
                  { key: "oldPosition", ph: "ຕຳແໜ່ງ" },
                  { key: "responsibilities", ph: "ຫນ້າທີ່ຫຼັກ" },
                  { key: "reasonForResignation", ph: "ເຫດຜົນລາອອກ" },
                  { key: "workExperience", ph: "1, 2, 3, ..." },
                ].map((c, i) => (
                  <div
                    key={`work-${rowIdx}-${i}`}
                    style={{
                      borderRight: i < 4 ? "1px solid #1f2937" : "none",
                      borderBottom: rowIdx < 2 ? "1px solid #1f2937" : "none",
                    }}
                  >
                    <input
                      type={c.key === "workExperience" ? "number" : "text"}
                      name={`previousPlaceOfWork[${rowIdx}][${
                        WORK_INDEX[c.key]
                      }]`}
                      value={
                        values.previousPlaceOfWork?.[rowIdx]?.[
                          WORK_INDEX[c.key]
                        ] || ""
                      }
                      onChange={handleChange}
                      placeholder={c.ph}
                      style={{
                        width: "100%",
                        padding: 10,
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        fontSize: "clamp(0.65rem, 1vw, 0.85rem)",
                      }}
                    />
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
        {errors.previousPlaceOfWork && (
          <p className="error-text">{errors.previousPlaceOfWork}</p>
        )}
      </div>

      {/* ໂປຣແກຣມ/ທັກສະ */}
      <div style={{ marginTop: "1.5rem" }}>
        <label
          style={{ ...labelStyle, fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}
        >
          ທັກສະຄອມພິວເຕີ້
          {!values.computerSkills && (
            <span className="text-danger" style={{ marginLeft: 4 }}>
              ❇
            </span>
          )}
        </label>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div
            style={{
              minWidth: "720px",
              display: "grid",
              gridTemplateColumns: "1.6fr repeat(4, 1fr)",
              border: "1.5px solid #1f2937",
              borderRadius: 6,
              overflow: "hidden",
              textAlign: "center",
            }}
          >
            {["ໂປຣແກຣມ/ທັກສະ", "ດີຫຼາຍ", "ດີ", "ປານກາງ", "ອ່ອນ"].map((h, i) => (
              <div
                key={`comp-h-${i}`}
                style={{
                  padding: 10,
                  fontWeight: 700,
                  fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  background: "#dc2626",
                  borderRight: i < 4 ? "1px solid #1f2937" : "none",
                  borderBottom: "1px solid #1f2937",
                  color: "white",
                }}
              >
                {h}
              </div>
            ))}

            <div
              style={{
                borderRight: "1px solid #1f2937",
                borderBottom: "1px solid #1f2937",
                display: "flex",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <span style={{ fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}>
                WORD / EXCEL / POWERPOINT
              </span>
            </div>
            {SKILL_LEVELS.map((level, i) => (
              <div
                key={`comp-row-${i}`}
                style={{
                  borderRight: i < 3 ? "1px solid #1f2937" : "none",
                  borderBottom: "1px solid #1f2937",
                }}
              >
                <input
                  type="radio"
                  name="computerSkills"
                  value={level}
                  checked={values.computerSkills === level}
                  onChange={handleChange}
                  style={{ width: 18, height: 18, marginTop: 8 }}
                />
              </div>
            ))}

            {/* otherComputerSkills */}
            <div
              style={{
                gridColumn: "1 / 6",
                borderBottom: "1px solid #1f2937",
                display: "flex",
                alignItems: "center",
                padding: "8px 10px",
                gap: 10,
              }}
            >
              <span style={{ fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}>
                ໂປຣແກຣມອື່ນໆ
              </span>
              <input
                type="text"
                name="otherComputerSkills"
                value={values.otherComputerSkills || ""}
                onChange={handleChange}
                placeholder="Photoshop, ERP, …"
                style={{
                  flex: 1,
                  border: "none",
                  borderBottom: "1px dotted #9ca3af",
                  background: "transparent",
                  outline: "none",
                }}
              />
            </div>
          </div>
        </div>
        {errors.computerSkills && (
          <p className="error-text">{errors.computerSkills}</p>
        )}
      </div>

      {/* ທັກສະພາສາ */}
      <div style={{ marginTop: "1.5rem" }}>
        <label
          style={{ ...labelStyle, fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}
        >
          ທັກສະພາສາ
          {!hasLanguageSkills && (
            <span className="text-danger" style={{ marginLeft: 4 }}>
              ❇
            </span>
          )}
        </label>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div
            style={{
              minWidth: "720px",
              display: "grid",
              gridTemplateColumns: "1.6fr repeat(4, 1fr)",
              border: "1.5px solid #1f2937",
              borderRadius: 6,
              overflow: "hidden",
              textAlign: "center",
            }}
          >
            {["ພາສາ", "ດີຫຼາຍ", "ດີ", "ປານກາງ", "ອ່ອນ"].map((h, i) => (
              <div
                key={`lang-h-${i}`}
                style={{
                  padding: 10,
                  fontWeight: 700,
                  fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  background: "#dc2626",
                  borderRight: i < 4 ? "1px solid #1f2937" : "none",
                  borderBottom: "1px solid #1f2937",
                  color: "white",
                }}
              >
                {h}
              </div>
            ))}

            {[
              { label: "ອັງກິດ", name: "englishSkills" },
              { label: "ຈີນ", name: "chineseSkills" },
              { label: "ວຽດນາມ", name: "vietnamSkills" },
            ].map((row, rIdx) => (
              <>
                <div
                  key={`lang-${rIdx}-label`}
                  style={{
                    borderRight: "1px solid #1f2937",
                    borderBottom: "1px solid #1f2937",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 10,
                    fontSize: "clamp(0.7rem, 1vw, 0.9rem)",
                  }}
                >
                  <span>{row.label}</span>
                </div>
                {SKILL_LEVELS.map((level, i) => (
                  <div
                    key={`lang-${rIdx}-${i}`}
                    style={{
                      borderRight: i < 3 ? "1px solid #1f2937" : "none",
                      borderBottom: "1px solid #1f2937",
                    }}
                  >
                    <input
                      type="radio"
                      name={row.name}
                      value={level}
                      checked={values[row.name] === level}
                      onChange={handleChange}
                      style={{ width: 18, height: 18, marginTop: 8 }}
                    />
                  </div>
                ))}
              </>
            ))}

            {/*  otherSkills */}
            <div
              style={{
                gridColumn: "1 / 6",
                display: "flex",
                alignItems: "center",
                padding: "8px 10px",
                gap: 10,
              }}
            >
              <span style={{ fontSize: "clamp(0.7rem, 1vw, 0.9rem)" }}>
                ພາສາອື່ນໆ
              </span>
              <input
                type="text"
                name="otherSkills"
                value={values.otherSkills || ""}
                onChange={handleChange}
                placeholder="…"
                style={{
                  flex: 1,
                  border: "none",
                  borderBottom: "1px dotted #9ca3af",
                  background: "transparent",
                  outline: "none",
                }}
              />
            </div>
          </div>
          {errors.skills && <p className="error-text">{errors.skills}</p>}
        </div>
        {/* {errors.skills && <p className="error-text">{errors.skills}</p>} */}
      </div>
    </>
  );
}
